import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/common/Elements/Elements';

import AdditionalContent from '../AdditionalContent/AdditionalContent';

import classes from './Massage.module.scss';

const Massage = ({ title, data, onOpenAdditionalModal }) => {
  return (
    <>
      {data.comments.length > 0 ? (
        <div>
          {data.comments.substr(0, 100)}{' '}
          {data.comments.length > 100 + 1 && (
            <Button
              className={classes.button}
              onClick={() =>
                onOpenAdditionalModal({
                  content: <AdditionalContent title={title} data={data} />
                })
              }
            >
              more...
            </Button>
          )}
        </div>
      ) : (
        'NA'
      )}
    </>
  );
};

Massage.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  onOpenAdditionalModal: PropTypes.func.isRequired
};

export default Massage;
